// gets the slug of a filter group and a filter within a group
export const getSlug = (value, filterGroups) => {
	let groupSlug;

	for (const filterGroup of filterGroups) {
		const filterIndex = filterGroup.filters.findIndex(filter => filter.title === value);
		
		if (filterIndex !== -1) {
			groupSlug = filterGroup.slug;
			break;
		}
	}

	const group = filterGroups.find(group => group.slug === groupSlug);
	const filter = group.filters.find(filter => filter.title === value);
	const filterSlug = filter.slug;

	return {groupSlug, filterSlug};
};
